<div class="flex h-full w-full flex-col overflow-y-auto p-4">
  <div class="mr-2 flex grow flex-col rounded-[48px] bg-background-white p-6 shadow-sm">
    @if (loading()) {
      <div class="flex h-full items-center justify-center">
        <ng-lottie currentcolor class="text-primary-blue" [options]="lottieOptions"></ng-lottie>
      </div>
    }

    <div class="grid grid-flow-col gap-4" [style.gridTemplateRows]="'repeat(' + numberOfRows() + ', 1fr)'">
      @for (item of items(); track $index) {
        <div
          class="relative flex items-center justify-between rounded-[13px] border-2 bg-background-light-blue px-3 py-[6px]"
          [ngClass]="isSelected(item) ? 'border-primary-blue' : 'border-background-light-blue'"
        >
          @if (isSelected(item)) {
            <div class="absolute left-0 top-0 h-full w-full rounded-[13px] bg-primary-blue/10"></div>
          }
          <span class="typo-h3-medium">{{ item.name }}</span>
          <button
            class="isolate z-10 flex h-[28px] w-[28px] items-center justify-center rounded-[10px] bg-background-white"
            (click)="isSelected(item) ? deselectItem(item) : selectItem(item)"
          >
            <svg-icon
              key="px-16-plus"
              size="sm"
              class="text-primary-blue transition-transform"
              [ngClass]="{
                'rotate-[135deg]': isSelected(item)
              }"
            ></svg-icon>
          </button>
        </div>
      }
    </div>
  </div>
</div>
